"use client";

import Link from "next/link";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function ForgotPassword() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setSuccess(true);
        setTimeout(() => {
          router.push(`/auth/reset-password?email=${encodeURIComponent(email)}`);
        }, 2000);
      } else {
        const data = await res.json();
        setError(data.error || "Something went wrong");
      }
    } catch {
      setError("Network error");
    }

    setLoading(false);
  }

  return (
    <section className="py-10">
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-[rgba(249,115,22,0.2)] border-2 border-[rgba(249,115,22,0.2)] rounded-xl shadow-lg p-8">
          <h2 className="text-3xl font-bold text-white mb-2 text-center">Forgot Password</h2>
          <p className="text-gray-400 text-sm text-center mb-6">
            Enter your email and we&apos;ll send you a reset code.
          </p>

          {error && (
            <p className="border-2 border-red-600 bg-red-200 rounded-lg text-red-700 p-2 my-3">
              {error}
            </p>
          )}
          {success && (
            <p className="border-2 border-[rgba(0,200,0,0.8)] bg-[rgba(0,200,0,0.3)] text-[rgb(0,200,0)] rounded-lg p-2 my-3">
              If an account with that email exists, a reset code has been sent. Redirecting...
            </p>
          )}

          {!success && (
            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label className="block mb-1 text-gray-300 text-sm font-extrabold">Email</label>
                <input
                  type="email"
                  className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
                  value={email}
                  placeholder="john@example.com"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-2 px-4 rounded-lg text-white font-semibold border-2 border-orange-700 bg-orange-400 hover:bg-orange-600 transition-all duration-200 ease-linear disabled:opacity-50"
              >
                {loading ? "Sending..." : "Send Reset Code"}
              </button>
            </form>
          )}

          <p className="text-sm text-gray-400 mt-6 text-center">
            Remember your password?{" "}
            <Link href="/auth/login" className="text-orange-400 hover:underline">
              Login
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
